import React from 'react';

const MatDashTableCard = ({
  title,
  subtitle,
  children,
  className = '',
  headerAction,
}) => (
  <div className={`md-card overflow-hidden ${className}`.trim()}>
    {(title || headerAction) && (
      <div className="px-5 py-4 border-b border-matdash-border/60 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <div>
          {title && <h5 className="text-base font-semibold text-matdash-dark mb-0">{title}</h5>}
          {subtitle && <p className="md-card-subtitle mt-0.5">{subtitle}</p>}
        </div>
        {headerAction}
      </div>
    )}
    {children}
  </div>
);

export default MatDashTableCard;
